import { DatasetStatus, SearchPreset } from '@retro-ui/api-contract';

import { formatBytes } from '@f/utils/text';

import { DatasetsById } from '../SearchParameterForm';

import { buildSelectedDatasetMap } from './buildDatasetMap';

export type DatasetValidation = ReturnType<typeof validateDatasets>;

export function validateDatasets(
  searchParams: SearchPreset,
  datasetsByExtendedId: DatasetsById,
  maxSize: number
) {
  const { datasets = [] } = searchParams ?? {};

  const validDatasets = Array.isArray(datasets)
    ? datasets.filter(datasetPartial => {
        const dataset = datasetsByExtendedId[datasetPartial.id];
        return dataset?.status === DatasetStatus.READY;
      })
    : [];

  const selectedDatasetMap = buildSelectedDatasetMap(validDatasets, datasetsByExtendedId);

  const selectedDatasetsTotalSize = Object.keys(selectedDatasetMap).reduce((acc, extendedId) => {
    const dataset = datasetsByExtendedId[extendedId];
    const size = Number.isFinite(dataset?.size) ? dataset.size : 0;

    return acc + size;
  }, 0);

  const areDatasetsEmpty = validDatasets.length === 0;
  const isDatasetSizeLimitExceeded = selectedDatasetsTotalSize > maxSize;

  return {
    isValid: !areDatasetsEmpty && !isDatasetSizeLimitExceeded,
    areDatasetsEmpty,
    isDatasetSizeLimitExceeded,
    datasetsEmptyMessage: 'Please select at least one starting material dataset.',
    datasetSizeLimitExceededMessage: `The total size of the selected private datasets exceeds the limit of ${formatBytes(
      maxSize
    )}. Please select fewer datasets.`,
  };
}
